import { computed, toValue, provide, ref, watch } from "vue";
import { u as useField } from "../../../vee-validate.esm-BdNRJGXy.js";
import { FieldTypes } from "../constants.mjs";
import { FormFieldContextKey } from "../Symbols.mjs";
import useGetWithinForm from "./useGetWithinForm.mjs";
function useCachedReactiveValidators(validators, disabled) {
  const validatorsSignature = computed(() => {
    if (toValue(disabled)) {
      return "";
    }
    return toValue(validators).map((v) => `${v.name}-${v.message}`).join("|");
  });
  const cachedValidators = ref([]);
  const reactiveValidators = ref([]);
  watch(
    validatorsSignature,
    (newSig, oldSig) => {
      if (newSig !== oldSig) {
        if (toValue(disabled)) {
          reactiveValidators.value = [];
          cachedValidators.value = [];
        } else {
          reactiveValidators.value = toValue(validators).map((v) => v.validate);
          cachedValidators.value = toValue(validators);
        }
      }
    },
    { immediate: true }
  );
  return reactiveValidators;
}
function useFormField(name, modelValue, { validators = [], fieldType, checkedValue, disabled } = {}) {
  const withinForm = useGetWithinForm();
  const validationRules = useCachedReactiveValidators(validators, disabled);
  const computedInitialValue = computed(() => {
    if (withinForm) {
      return void 0;
    }
    return modelValue;
  });
  const computedCheckedValue = computed(() => {
    if (fieldType === FieldTypes.CHECKBOX) {
      return true;
    }
    if (fieldType === FieldTypes.RADIO) {
      return checkedValue;
    }
    return void 0;
  });
  const {
    value,
    checked,
    meta,
    setValue,
    errorMessage,
    handleBlur,
    handleChange,
    setErrors
  } = useField(name, validationRules, {
    initialValue: computedInitialValue.value,
    standalone: !withinForm,
    ...fieldType === FieldTypes.CHECKBOX || fieldType === FieldTypes.RADIO ? {
      type: fieldType,
      checkedValue: computedCheckedValue.value
    } : {}
  });
  const errorRuleName = computed(() => {
    const failingRule = toValue(validators).find(
      (validator) => errorMessage.value === validator.message
    );
    return failingRule ? failingRule.name : void 0;
  });
  provide(FormFieldContextKey, {
    name,
    value,
    validators,
    fieldType
  });
  return {
    value,
    checked,
    meta,
    errorMessage,
    errorRuleName,
    withinForm,
    setValue,
    handleBlur,
    handleChange,
    setErrors
  };
}
export {
  useFormField as default
};
//# sourceMappingURL=useFormField.mjs.map
